// The drawn neighbours of the regular game (art/aseprite/src/neighbour_heads.lua): now and then a visitor at the glass is Many-Eyes, the moth
// in its lampshade, the set, the spider, the goblin, the brain (in a cap or in horns), the cop frog, the bouffant, the hood, the rasta bird or
// the skull. Art only, by seed only, like the degen visitors (game/degens.js), so an alien can wear one too and the look gives nothing away.
export const REGULARS = ['n-eyes', 'n-moth', 'n-set', 'n-spider', 'goblin', 'brain-cap', 'brain-horns', 'copfrog', 'bouffant', 'hood', 'rasta', 'skull'];

// share of regular visitors who turn up as one of them (on top of the degen visitors' own share)
export const REGULAR_SHARE = 0.1;

const fmix = h => { h >>>= 0; h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16; return h >>> 0; };
export function regularOf(seed) {
  const h = fmix((seed ^ 0x61c88647) >>> 0);
  if (h / 4294967296 >= REGULAR_SHARE) return null;
  return REGULARS[fmix(h ^ 0x9e3779b9) % REGULARS.length];
}
